import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FormControlLabel from 'housecall-ui/dist/DesignSystem/Inputs/FormControls/FormControlLabel';
import Switch from 'housecall-ui/dist/DesignSystem/Inputs/Switches/Switch';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import { DECLINED_STATUS, ENABLED_STATUS } from '../../../../Resources/ConsumerLending/Lenders/Data';
import { updateAppStatusInEntities } from '../../../../Resources/Organization/Apps/AppsActions.js';
import AppsApi from '../../../../Resources/Organization/Apps/AppsApi.js';
import { useDataFetcherV2 } from '../../../Common/Data/useDataFetcher';
import { fetchAppStatus, getAppEnabled, getAppStatus } from '../../../../Resources/Organization/Apps/AppsData';
import { STATE_DISABLED, STATE_ENABLED, WISETACK } from '../AppsData';
import WisetackButton from './WisetackButton';
import { useConsumerFinancingFeatureEnabled } from 'components/ConsumerFinancing/hooks/useConsumerFinancingFeatureEnabled';
import { ConsumerFinancingRedirectButton } from 'components/ConsumerFinancing/components/ConsumerFinancingRedirectButton/ConsumerFinancingRedirectButton';

const STATUSES = [ENABLED_STATUS, DECLINED_STATUS];

const WisetackToggleAndButton = () => {
  const [statusFetched] = useDataFetcherV2(fetchAppStatus(WISETACK));
  const wisetackAppStatus = useSelector(getAppStatus(WISETACK));
  const appEnabled = useSelector(getAppEnabled(WISETACK));
  const consumerFinancingEnabled = useConsumerFinancingFeatureEnabled();
  const [checked, setChecked] = useState(appEnabled);
  const [submitting, setSubmitting] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    setChecked(appEnabled);
  }, [appEnabled]);

  const showToggle = STATUSES.includes(wisetackAppStatus.status) || wisetackAppStatus.transactions_enabled === true;
  const disableToggle = wisetackAppStatus.status === DECLINED_STATUS || submitting;
  const showButton = !STATUSES.includes(wisetackAppStatus.status);

  const onToggleChange = () => {
    setChecked(!checked);
    setSubmitting(true);

    AppsApi.updateApp(WISETACK, { state: !appEnabled ? STATE_ENABLED : STATE_DISABLED })
      .then(() => {
        dispatch(updateAppStatusInEntities(WISETACK, { ...wisetackAppStatus, is_enabled: !appEnabled }));
      })
      .finally(() => setSubmitting(false));
  };

  if (consumerFinancingEnabled) {
    return <ConsumerFinancingRedirectButton />;
  }

  if (!statusFetched) {
    return <></>;
  }

  return (
    <Grid container>
      <Grid item xs={12}>
        {showToggle && (
          <FormControlLabel
            control={<Switch checked={checked} disabled={disableToggle} onChange={onToggleChange} />}
            label={checked ? 'Active' : 'Disabled'}
          />
        )}
      </Grid>
      <Grid item xs={12}>
        {showButton && (
          <WisetackButton
            buttonLocation="wisetack app details"
            applicationUrl={wisetackAppStatus.lender_application_url}
            usePendingLanguage={wisetackAppStatus.use_pending_language}
          />
        )}
      </Grid>
    </Grid>
  );
};

export default WisetackToggleAndButton;
